import { toast } from "sonner";
import { Check, Lock, Unlock, Flag } from "lucide-react";
import { daySubmissions } from "@/lib/verify";

const timeOf = (iso) => { try { return new Date(iso).toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" }); } catch { return ""; } };

// Live-tab overview of which groups have submitted their card; organiser can close or reopen a group.
export function GroupsInPanel({ day, updateScores, canEdit }) {
  const subs = daySubmissions(day);
  if (subs.total === 0) return null;
  const submitOp = (gi, value) => ({ dayId: day.id, groupIdx: gi, holeIdx: 0, submit: { value } });
  const close = (gi) => {
    if (!window.confirm(`Close Group ${String.fromCharCode(65 + gi)} and lock its scores?`)) return;
    updateScores([submitOp(gi, true)]);
    toast.success(`Group ${String.fromCharCode(65 + gi)} closed`);
  };
  const reopen = (gi) => { updateScores([submitOp(gi, false)]); toast.info(`Group ${String.fromCharCode(65 + gi)} reopened`); };

  return (
    <div className="tga-card-dark" data-testid="groups-in-panel">
      <div className="flex items-center justify-between mb-2">
        <div className="font-display text-lg text-[color:var(--brass-bright)]">Groups in</div>
        <div className={`font-mono-metrics text-sm ${subs.allIn ? "text-emerald-400" : "text-[color:var(--muted-green)]"}`} data-testid="groups-in-count">{subs.submitted}/{subs.total}</div>
      </div>
      <div className="grid grid-cols-2 gap-2">
        {subs.groups.map((s, gi) => {
          const letter = String.fromCharCode(65 + gi);
          const inn = !!s.submitted;
          return (
            <div
              key={gi}
              data-testid={`groups-in-tile-${gi}`}
              className={`rounded-xl border p-2.5 flex flex-col gap-1 ${inn ? "border-emerald-500/40 bg-emerald-900/25" : "border-[color:var(--border-brass-light)] bg-[rgba(255,255,255,0.03)]"}`}
            >
              <div className="flex items-center justify-between">
                <div className="text-sm font-semibold text-[color:var(--brass-bright)]">Group {letter}</div>
                {inn ? <Check size={14} className="text-emerald-400" /> : <Flag size={13} className="text-[color:var(--muted-green)]" />}
              </div>
              <div className="text-[11px] text-[color:var(--muted-green)]" data-testid={`groups-in-status-${gi}`}>
                {inn
                  ? `In · ${timeOf(s.submitted.at)}${s.submitted.byOrganizer ? " · organiser" : ""}`
                  : s.complete
                    ? `18 in · ${s.attested.length}/${s.group.playerIds.length} signed`
                    : `Hole ${Math.max(1, s.lastPlayed + 1)} · ${s.holesDone}/18`}
              </div>
              {canEdit && !day.finalized && (
                inn ? (
                  <button data-testid={`groups-in-reopen-${gi}`} className="ghost-btn rounded-lg px-2 py-1.5 text-[11px] inline-flex items-center justify-center gap-1 mt-1" onClick={() => reopen(gi)}><Unlock size={11} /> Reopen</button>
                ) : (
                  <button data-testid={`groups-in-close-${gi}`} className="ghost-btn rounded-lg px-2 py-1.5 text-[11px] inline-flex items-center justify-center gap-1 mt-1" onClick={() => close(gi)}><Lock size={11} /> Close group</button>
                )
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}
